import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer id="footer" className="footer">
      <div className="footer-glow"></div>
      <div className="footer-container">
        
        {/* Top Call-to-action bar */}
        <div className="footer-cta-card">
          <div className="footer-cta-content">
            <span className="footer-cta-tag">READY TO SCALE YOUR VISION?</span>
            <h3 className="footer-cta-title">Let's Build Intelligent, High-Performance Software</h3>
            <p className="footer-cta-desc">
              Partner with Softora’s dedicated engineering team to transform your business requirements into reliable digital products.
            </p>
          </div>
          <Link to="/contact" className="footer-cta-button">
            <span>START A PROJECT</span>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 12H19M19 12L12 5M19 12L12 19" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </Link>
        </div>

        {/* Main Footer Grid */}
        <div className="footer-grid">
          
          {/* Brand Info */}
          <div className="footer-brand-col">
            <Link to="/" className="footer-logo">
              <img src="/logo.png" alt="SOFTORA" className="footer-logo-image" />
            </Link>
            <p className="footer-brand-desc">
              Softora is a premier software company delivering custom enterprise software, mobile & web applications, AI integrations, and cloud infrastructure.
            </p>
            
          </div>

          {/* Quick Links */}
          <div className="footer-col">
            <h4 className="footer-col-title">NAVIGATION</h4>
            <ul className="footer-links-list">
              <li><Link to="/" className="footer-nav-link">Home</Link></li>
              <li><Link to="/about" className="footer-nav-link">About Softora</Link></li>
              <li><Link to="/services" className="footer-nav-link">Our Services</Link></li>
              <li><Link to="/technologies" className="footer-nav-link">Technologies</Link></li>
              <li><Link to="/contact" className="footer-nav-link">Contact Us</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-col">
            <h4 className="footer-col-title">SERVICES</h4>
            <ul className="footer-links-list">
              <li><Link to="/services" className="footer-nav-link">Web Applications (React/Next)</Link></li>
              <li><Link to="/services" className="footer-nav-link">Mobile Apps (Flutter/iOS)</Link></li>
              <li><Link to="/services" className="footer-nav-link">Cloud Solutions & Firebase</Link></li>
              <li><Link to="/services" className="footer-nav-link">AI & Automation</Link></li>
              <li><Link to="/services" className="footer-nav-link">IT Architecture & Consulting</Link></li>
            </ul>
          </div>

          {/* Contact Details */}
          <div className="footer-col">
            <h4 className="footer-col-title">CONTACT & INQUIRIES</h4>
            <ul className="footer-contact-list">
              <li>
                <span className="contact-label">Email:</span>
                <a href="mailto:support@getsoftora.com" className="footer-contact-link">support@getsoftora.com</a>
              </li>
              <li>
                <span className="contact-label">WhatsApp / Direct:</span>
                <a href="https://wa.me/94785452899" target="_blank" rel="noopener noreferrer" className="footer-contact-link">+94 78 545 2899</a>
              </li>
              <li>
                <span className="contact-label">Working Hours:</span>
                <span className="contact-text">Mon - Sat: 9:00 AM - 7:00 PM</span>
              </li>
            </ul>

            <div className="footer-social-icons">
              <a href="https://wa.me/94785452899" target="_blank" rel="noopener noreferrer" className="social-icon-btn" title="WhatsApp">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21 5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.816 9.816 0 0 0 12.04 2zm.01 1.67c2.2 0 4.26.86 5.82 2.42a8.225 8.225 0 0 1 2.41 5.83c0 4.54-3.7 8.24-8.24 8.24-1.45 0-2.87-.38-4.12-1.1l-.3-.17-3.12.82.83-3.04-.19-.3a8.217 8.217 0 0 1-1.25-4.38c0-4.54 3.7-8.24 8.24-8.24zm-3.53 4.19c-.19 0-.41.07-.63.31-.22.24-.84.82-.84 2 0 1.18.86 2.32.98 2.48.12.16 1.7 2.6 4.12 3.64.58.25 1.03.4 1.38.51.58.18 1.11.16 1.53.1.47-.07 1.44-.59 1.64-1.16.2-.57.2-1.06.14-1.16-.06-.1-.22-.16-.47-.28-.25-.12-1.44-.71-1.67-.79-.22-.08-.38-.12-.55.12-.16.24-.63.79-.77.95-.14.16-.28.18-.53.06-.25-.12-1.05-.39-2-1.23-.74-.66-1.23-1.47-1.38-1.72-.14-.25-.02-.38.11-.5.11-.11.25-.28.38-.43.12-.14.16-.24.25-.4.08-.16.04-.3-.02-.43-.06-.12-.55-1.32-.75-1.81-.2-.48-.4-.41-.55-.42l-.47-.01z"/>
                </svg>
              </a>
              <a href="mailto:support@getsoftora.com" className="social-icon-btn" title="Email Us">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-icon-btn" title="LinkedIn">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.28 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.75M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom copyright bar */}
        <div className="footer-bottom">
          <div className="footer-copyright">
            © {new Date().getFullYear()} SOFTORA Technologies. All rights reserved.
          </div>
          <div className="footer-legal-links">
            <Link to="/about" className="legal-link">Privacy Policy</Link>
            <span className="legal-dot">•</span>
            <Link to="/about" className="legal-link">Terms of Service</Link>
            <span className="legal-dot">•</span>
            <Link to="/contact" className="legal-link">Support</Link>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;